import { useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Loading } from '../Loading/Loading';
import './ConfirmWithLoader.css'

export default function ConfirmWithLoader({
  showModal,
  setShowModal,
  onConfirm,
  onClose,
  isLoading = false,
  isFinish = false,
  title,
  children,
  textButtonCancel = "Cancelar",
  textButton = "Confirmar",
  disabledConfirmButton = false,
  hideContentInLoading = true,
  hideActionAfterConfirm = true,
  size = "md",
  scrollToHeader = false
}) {

  const modalHeaderRef = useRef();

  const handleCloseModal = () => {
    setShowModal(false);
    // onClose && onClose();
  };

  const handleExitedModal = () => {
    // setShowModal(false);
    onClose && onClose();
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
  };

  useEffect(() => {
    if (scrollToHeader) {
      const modalElement = modalHeaderRef.current?.dialog;
      const headerElement = modalElement?.querySelector('.modal-header');
      if (headerElement) {
        headerElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [scrollToHeader]);

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal} onExited={handleExitedModal} backdrop="static" keyboard={false} size={size} ref={modalHeaderRef}>
        <Modal.Header >
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {hideContentInLoading ? (
            isLoading && !isFinish ? (
              <div className="text-center">
                <div>
                  <Loading></Loading>
                </div>
              </div>
            ) : (
              children
            )
          ) : (
            <>
              {isLoading && !isFinish && (
                <>
                  <div className="confirmWithLoader-overlay">
                    <div className='position-absolute top-50 start-50 translate-middle'>
                      <Loading></Loading>
                    </div>
                  </div>


                </>

              )}
              {children}
            </>
          )}

        </Modal.Body>
        <Modal.Footer>

          {hideActionAfterConfirm ? (
            <>
              {!isLoading && !isFinish && (
                <>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    {textButtonCancel}
                  </Button>
                  <Button disabled={disabledConfirmButton} variant="primary" onClick={handleConfirm}>
                    {textButton}
                  </Button>
                </>
              )}
              {!isLoading && isFinish && (
                <Button variant="secondary" onClick={handleCloseModal}>
                  Cerrar
                </Button>
              )}
            </>
          ) : (
            <>
              {!isLoading ? (
                <>
                  <Button variant="secondary" onClick={handleCloseModal}>
                  {textButtonCancel}
                  </Button>
                  <Button disabled={disabledConfirmButton} variant="primary" onClick={handleConfirm}>
                    {textButton}
                  </Button>
                </>
              ) : (
                <>
                  <Button variant="secondary" disabled={true}>
                  {textButtonCancel}
                  </Button>
                  <Button disabled={true} variant="primary" >
                    {textButton}
                  </Button>
                </>
              )}
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};